import { createUseStyles } from 'react-jss';
import { Breakpoints } from '@/lib/breakpoints';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    headerSkeleton: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s16,
      marginTop: Spacings.s16,
      [Breakpoints.SM]: { marginTop: Spacings.s32 },
    },
    gridSection: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      marginTop: Spacings.s8,
      paddingTop: Spacings.s24,
      paddingBottom: Spacings.s24,
    },
    presetHero: { display: 'flex', flexDirection: 'column', gap: Spacings.s4 },
    presetSimilar: { marginTop: Spacings.s40, display: 'flex', flexDirection: 'column', gap: 28 },
  },
  { name: 'skeleton-layout' },
);

export default useStyles;
